<form [formGroup]="form" class="p-2">
	<div class="form-group mb-3">
		<nz-form-item>
			<nz-form-label nzFor="date">Date Filter</nz-form-label>
			<nz-form-control>
				<nz-date-picker formControlName="endDate"></nz-date-picker>
			</nz-form-control>
		</nz-form-item>
	</div>

	<div class="form-group mb-4">
		<label nz-checkbox formControlName="includeSummary">Include Summary Page</label>
	</div>

	<div class="text-end">
		<button nz-button nzType="default" (click)="handleCancel()" [disabled]="running">Cancel</button>
		<button nz-button nzType="primary" (click)="handleDownload()" [disabled]="form.invalid || running">
			<ng-container *ngIf="running">Running...</ng-container>
			<ng-container *ngIf="!running">Download</ng-container>
		</button>
	</div>
</form>
